var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.96 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #dd7e00;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.69,28.42c1.01-4.91,3.77-18.15,3.77-18.15,0,0-4.21,2.33-6.01,3.32-2.92,1.62-5.63,.96-7.5-1.81,0,0-6.82-10.08-6.97-10.29-.15,.21-6.97,10.29-6.97,10.29-1.87,2.77-4.58,3.43-7.5,1.81-1.8-1-6.01-3.32-6.01-3.32,0,0,2.76,13.24,3.77,18.15H38.69Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.03,
    y1: 36.5,
    x2: 37.94,
    y2: 36.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.4adca2865a58b9b4818ee486bd90dcd2.svg";
export { ForwardRef as ReactComponent };